module.exports = __webpack_public_path__ + "img/roobroo-wordmark.a01ea566.svg";